import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppModule as CommonAppModule } from '@caslink/common-client/ng-app/module';
import { AppModule as DeviceAppModule } from '@caslink/device-client/ng-app/module';
import MonitoringModule from '@caslink/monitoring-client/ngx-app/module';

import { AppRoutingModule } from './app-routing.module';
import { CasComponent } from './cas.component';

import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UpgradeModule } from '@angular/upgrade/static';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ToastrModule } from 'ngx-toastr';
import { CaslinkCommonModule } from './modules/common/caslink-common.module';
import { NewVersionAvailableMessageComponent } from './modules/common/components/banner/messages/new-version-available-message.component';
import { NoInternetMessageComponent } from './modules/common/components/banner/messages/no-internet-message.component';
import { NoServiceMessageComponent } from './modules/common/components/banner/messages/no-service-message.component';
import { RenewSubscriptionModule } from './modules/common/components/subscription-renew/renew-subscription.module';
import { LegacyModule } from './modules/legacy/legacy.module';
import { PortalModule } from './modules/portal/portal.module';
import { AndroidMessageComponent } from './modules/pwa/component/android-message.component';
import { IosMessageComponent } from './modules/pwa/component/ios-message.component';
import { PwaService } from './modules/pwa/services/pwa.service';
import { UserModule } from './modules/user/user.module';
import { FavoritesInstructionMessageComponent } from './modules/common/components/banner/messages/favorites-instruction-message.component';
import { PlacesInstructionMessageComponent } from './modules/common/components/banner/messages/places-instruction-message.component';
import { SpacesInstructionMessageComponent } from './modules/common/components/banner/messages/spaces-instruction-message.component';
import { HammerModule } from '@angular/platform-browser';

// Remove this import after common-client is converted to new Angular
import * as angular from 'angular';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { ProxyAdapterService } from './modules/devices/controls/services/proxy-adapter.service';
angular.module('app.areas.devices', ['app.areas.common']);

const initializer = (pwaService: PwaService) => () => pwaService.initPwaBanner();

@NgModule({
    declarations: [
        CasComponent,
        AndroidMessageComponent,
        IosMessageComponent,
        NewVersionAvailableMessageComponent,
        NoInternetMessageComponent,
        NoServiceMessageComponent,
        FavoritesInstructionMessageComponent,
        PlacesInstructionMessageComponent,
        SpacesInstructionMessageComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        CaslinkCommonModule.forRoot(),
        CommonAppModule,
        CommonModule,
        DeviceAppModule,
        DeviceDetectorModule.forRoot(),
        HammerModule,
        LegacyModule.forRoot(),
        MatDialogModule,
        MatIconModule,
        PortalModule,
        ServiceWorkerModule.register('caslink-service-worker.js'),
        UpgradeModule,
        UserModule,
        MatSliderModule,
        ToastrModule.forRoot(),
        RenewSubscriptionModule,
        MonitoringModule,
    ],
    bootstrap: [CasComponent],
    providers: [
        {provide: APP_INITIALIZER, useFactory: initializer, deps: [PwaService], multi: true},
        {
            provide: ProxyService,
            useClass: ProxyAdapterService,
        },
    ]
})
export class CasModule {
}
